export default "__VITE_ASSET__ba42fa61__"